import { DivIcon, Util, Marker, latLng } from "leaflet";
import { MapHtml } from "../map-html";
import { Colors } from "../markerColors";
import { MapStation } from "../../../core/models";
import { LanguageService } from "../../../core/services";

export class StationMarkerBuilder {
  static buildMarker(stop: MapStation, langService: LanguageService): Marker {
    const position = latLng(stop.lat, stop.lon);
    let iconSettings = {
      mapIconColor: StationMarkerBuilder.getStopColor(stop.sourceType),
      mapIconUrl: MapHtml.getStopIcon()
    };

    let divIcon = new DivIcon({
      className: "stopIcon",
      html: Util.template(iconSettings.mapIconUrl, iconSettings),
      iconAnchor: [12, 12],
      iconSize: [25, 25],
      popupAnchor: [0, -12]
    });

    const options = {
      icon: divIcon,
      stopId: stop.id,
    }

    const marker = new Marker(position, options);

    marker.bindPopup(MapHtml.getStopPopup(stop, langService), { closeButton: false });

    marker.on('mouseover', function (e) {
      marker.openPopup();
    });

    marker.on('mouseout', function (e) {
      marker.closePopup();
    });

    return marker;
  }

  private static getStopColor(sourceType: string) {
    if (sourceType == 'K')
      return Colors.colors[0];
    if (sourceType == 'S')
      return Colors.colors[1];
    else
      return Colors.colors[2];
  }
}
